// Version : 0.0.2
// Author :
// LastEdit : VISHAL BHARATHI
// Last ADD : UNNECESSARY PARTS REMOVED
// MODIFIED DATE: 19-09-2025

import { takeLatest, put, all, call } from 'redux-saga/effects';
import WalletReportActionTypes from './wallet-report.types';
import { fetchGroupMember, fetchWalletReport } from './wallet-report.service';
import {
	// FETCH GROUP MEMBER RESPONSE
	fetchGroupMemberDetailsSuccess,
	fetchGroupMemberDetailsFailure,
	fetchGroupMemberDetailsResponseChanged,

	// FETCH WALLET RESPONSE
	fetchWalletReportSuccess,
	fetchWalletReportFailure,
	fetchWalletReportResponseChanged,
} from './wallet-report.action';
import { encryptData } from '../../_common/enode-decode';

import AlertManager from '../../../utils/alertManager';
/** *********************  START FETCH GROUP MEMBER DETAILS ******************** */
export function* fetchGroupMemberData({ payload }: any) {
	try {
		const key = 'GetGroupMemberListKey';
		const { databaseName, branchID, groupID, centerID, companyID } = payload;
		const jsonData = {
			DatabaseName: databaseName,
			BranchID: branchID,
			CenterID: centerID,
			GroupID: groupID,
			CompanyID: companyID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchGroupMember, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchGroupMemberDetailsFailure(responseData.data));
		} else {
			yield put(fetchGroupMemberDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchGroupMemberDetailsFailure(error));
	}
}

export function* resetFetchGroupMemberResponse() {
	yield put(fetchGroupMemberDetailsResponseChanged());
}

export function* onFetchGroupMemberDetails() {
	yield takeLatest(WalletReportActionTypes.FETCH_GROUP_MEMBER_START, fetchGroupMemberData);
}

export function* onFetchGroupMemberResponseReset() {
	yield takeLatest(
		WalletReportActionTypes.FETCH_GROUP_MEMBER_RESPONSE_RESET,
		resetFetchGroupMemberResponse,
	);
}
/** ********************* END FETCH GROUP MEMBER DETAILS******************** */

/** *********************  START FETCH WALLET REPORT DETAILS ******************** */
export function* fetchWalletReportDetails({ payload }: any) {
	try {
		const key = 'GetWalletCollectionReportKey';
		const {
			companyID,
			branchID,
			groupID,
			databaseName,
			funderID,
			fromDate,
			toDate,
			tillDate,
			centerID,
			TABSLOANTYPE,
			searchDataType,
			memberID,
			limit,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			BranchID: branchID,
			GroupID: groupID,
			DatabaseName: databaseName,
			FunderID: funderID,
			FromDate: fromDate,
			ToDate: toDate,
			TillDate: tillDate,
			CenterID: centerID,
			MemberID: memberID,
			LoanType: TABSLOANTYPE,
			SearchDateType: searchDataType,
			Limit: limit,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchWalletReport, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchWalletReportFailure(responseData.data));
		} else {
			yield put(fetchWalletReportSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchWalletReportFailure(error));
	}
}

export function* resetFetchWalletReportResponse() {
	yield put(fetchWalletReportResponseChanged());
}

export function* onFetchWalletReport() {
	yield takeLatest(WalletReportActionTypes.FETCH_WALLET_REPORT_START, fetchWalletReportDetails);
}

export function* onFetchWalletReportResponseReset() {
	yield takeLatest(
		WalletReportActionTypes.FETCH_WALLET_REPORT_RESPONSE_RESET,
		resetFetchWalletReportResponse,
	);
}
/** ********************* END FETCH WALLET REPORT DETAILS ******************** */

export function* walletReportSaga() {
	yield all([
		call(onFetchGroupMemberDetails),
		call(onFetchGroupMemberResponseReset),
		call(onFetchWalletReport),
		call(onFetchWalletReportResponseReset),
	]);
}
